import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Facebook, Quote } from "lucide-react";
import { BIZ, REVIEW } from "./trenasData";
import TrenasLayout, { NAVY, GOLD, CREAM, SLATE } from "./TrenasLayout";
import LawInquiryForm from "@/components/LawInquiryForm";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function TrenasContact() {
  return (
    <TrenasLayout active="contact">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}>Contact</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 trenas-serif text-3xl sm:text-5xl text-white">Iloilo City Office</motion.h1>
        </div>
      </section>

      {/* CLIENT FEEDBACK */}
      <section className="py-14" style={{ background: CREAM }}>
        <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
          <motion.p {...fadeUp} className="text-sm mb-6" style={{ color: SLATE }}>{REVIEW.aggregateNote}</motion.p>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-7 shadow-sm">
            <Quote size={26} style={{ color: GOLD }} className="mx-auto mb-3" />
            <p className="text-base" style={{ color: NAVY }}>"{REVIEW.quote}"</p>
            <a href={REVIEW.sourceUrl} target="_blank" rel="noopener noreferrer" className="mt-4 inline-block text-xs underline" style={{ color: GOLD }}>{REVIEW.source} · {REVIEW.date}</a>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-10">
          <motion.div {...fadeUp}>
            <h2 className="trenas-serif text-2xl mb-6" style={{ color: NAVY }}>Get in Touch</h2>
            <div className="rounded-lg overflow-hidden shadow-sm mb-6">
              <img src="/law/trenas-law-iloilo-concept/letterhead.png" alt="The firm's official letterhead" className="w-full h-auto object-cover" />
            </div>
            <ul className="space-y-4 text-sm mb-6">
              <li className="flex items-start gap-3"><MapPin size={18} style={{ color: GOLD }} className="mt-0.5 shrink-0" />{BIZ.address}</li>
              <li className="flex items-start gap-3"><Phone size={18} style={{ color: GOLD }} className="mt-0.5 shrink-0" /><a href={`tel:${BIZ.phone}`} data-testid="trenas-phone-link" className="hover:underline">{BIZ.phoneDisplay}</a> / {BIZ.phoneAlt}</li>
              <li className="flex items-start gap-3"><Mail size={18} style={{ color: GOLD }} className="mt-0.5 shrink-0" /><a href={`mailto:${BIZ.email}`} data-testid="trenas-email-link" className="hover:underline">{BIZ.email}</a></li>
              <li className="flex items-start gap-3"><Facebook size={18} style={{ color: GOLD }} className="mt-0.5 shrink-0" /><a href={BIZ.facebook} target="_blank" rel="noopener noreferrer" data-testid="trenas-facebook-link" className="hover:underline">trenaslawoffice</a></li>
            </ul>
            <div className="rounded-lg overflow-hidden shadow-sm min-h-[220px]">
              <iframe title="Treñas Law Office map" src={BIZ.mapEmbed} className="w-full h-full min-h-[220px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </motion.div>
          <motion.div {...fadeUp}>
            <LawInquiryForm
              testidPrefix="trenas"
              businessName={BIZ.name}
              accent={NAVY}
              accentText="#FFFFFF"
              areasOfLaw={["Civil", "Commercial / Business", "Criminal", "Family", "Tax", "Property / Contracts", "Other / Not sure"]}
              phone={BIZ.phone}
              phoneDisplay={BIZ.phoneDisplay}
              email={BIZ.email}
              messengerUrl={BIZ.facebook}
            />
          </motion.div>
        </div>
      </section>
    </TrenasLayout>
  );
}
